import { jsxs as g, jsx as n, Fragment as $ } from "react/jsx-runtime";
import { useMemo as M, useId as I } from "react";
import { c as x } from "../clsx-OuTLNxxd.js";
import { L as w } from "../Label-B9Ttm_DE.js";
import '../PerformanceIndicator.css';const v = "320px", O = "600px", k = "1025px", A = "_performanceIndicator_oihz1_32", L = "_container_oihz1_36", j = "_percentage_oihz1_48", F = "_label_oihz1_56", P = "_indicatorWrapper_oihz1_63", R = "_hasMaxWidth_oihz1_71", C = "_indicator_oihz1_63", D = "_success_oihz1_82", E = "_failure_oihz1_86", G = "_neutral_oihz1_90", U = "_dateTop_oihz1_94", Y = "_dateBottom_oihz1_95", q = "_teamName_oihz1_111", t = {
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  mobile: v,
  "mobile-wide": "480px",
  tablet: O,
  "tablet-wide": "800px",
  desktop: k,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  performanceIndicator: A,
  container: L,
  "spacing-s": "_spacing-s_oihz1_42",
  "spacing-m": "_spacing-m_oihz1_45",
  percentage: j,
  label: F,
  indicatorWrapper: P,
  hasMaxWidth: R,
  indicator: C,
  success: D,
  failure: E,
  neutral: G,
  dateTop: U,
  dateBottom: Y,
  teamName: q
}, W = (a) => {
  switch (a) {
    case "WON":
      return t.success;
    case "LOST":
      return t.failure;
    default:
      return t.neutral;
  }
}, b = ({ children: a, className: d, count: c, label: i, position: m, spacing: o }) => {
  const r = I();
  return /* @__PURE__ */ g("div", { className: x(t.performanceIndicator, d), "data-cxy-name": "performance-indicator", children: [
    i && /* @__PURE__ */ n(w, { className: t.label, htmlFor: r, children: i }),
    /* @__PURE__ */ n(
      "div",
      {
        "aria-label": "Performance Indicator",
        className: x(t.container, t[`spacing-${o}`]),
        id: r,
        role: "group",
        style: {
          "--indicator-count": c,
          justifyContent: m === "start" ? "flex-end" : "flex-start"
        },
        children: a
      }
    )
  ] });
}, X = ({
  americanFormat: a = !1,
  awayText: d = "A",
  className: c,
  formatDate: i,
  hasMaxWidth: m = !0,
  history: o,
  hitRate: r,
  homeText: f = "H",
  label: H,
  limit: y,
  position: S = "end",
  showHitRate: N = !0,
  showMatchInformation: u = !1,
  spacing: T = "m"
}) => {
  const B = M(
    () => [...o].sort((e, s) => new Date(s.startTime).getTime() - new Date(e.startTime).getTime()).slice(0, y),
    [o, y]
  ), _ = (e) => {
    const s = new Date(e), h = s.getMonth() + 1, l = s.getDate();
    return a ? `${h}/${l}` : `${l}/${h}`;
  }, z = (e, { showFullName: s } = {}) => {
    const h = e.participant.side === "AWAY", l = h ? e.homeTeam : e.awayTeam, p = s ? l.name : l.shortName;
    return a ? h ? `@${p}` : p || l.name : e.participant.side === "HOME" ? `${p} (${f})` : `${p} (${d})`;
  };
  return o.length ? /* @__PURE__ */ g(b, { className: c, count: o.length, label: H, position: S, spacing: T, children: [
    N && /* @__PURE__ */ g("span", { className: t.percentage, "data-testid": "hit-rate", children: [
      r,
      "%"
    ] }),
    B.map((e, s) => /* @__PURE__ */ g(
      "div",
      {
        className: x(t.indicatorWrapper, {
          [t.hasMaxWidth]: m
        }),
        "data-testid": "indicator",
        children: [
          u && /* @__PURE__ */ n("span", { className: t.dateTop, "data-testid": "date-top", children: i ? i(e.startTime, "M/d") : _(e.startTime) }),
          /* @__PURE__ */ n(
            "div",
            {
              "aria-label": `${e.participant.betResult === "WON" ? "Success" : e.participant.betResult === "LOST" ? "Failure" : "Undetermined"} against ${z(e)}`,
              className: x(t.indicator, W(e.participant.betResult)),
              role: "img"
            }
          ),
          u && /* @__PURE__ */ g($, { children: [
            /* @__PURE__ */ n("span", { className: t.teamName, children: z(e) }),
            /* @__PURE__ */ n("span", { className: t.dateBottom, "data-testid": "date-bottom", children: i ? i(e.startTime, "M/d") : _(e.startTime) })
          ] })
        ]
      },
      s
    ))
  ] }) : null;
}, Z = ({
  className: a,
  hasMaxWidth: d,
  history: c,
  label: i,
  position: m,
  spacing: o
}) => c.length ? /* @__PURE__ */ n(b, { className: a, count: c.length, label: i, position: m, spacing: o, children: c.map((r, f) => /* @__PURE__ */ n(
  "div",
  {
    className: x(t.indicatorWrapper, {
      [t.hasMaxWidth]: d
    }),
    "data-testid": "indicator",
    children: /* @__PURE__ */ n("div", { className: x(t.indicator, W(r)), role: "img" })
  },
  f
)) }) : null;
export {
  X as PerformanceIndicator,
  Z as TipsterPerformanceIndicator
};
